module.exports = require("canvas-toBlob");